import { FC } from 'react';
import { Button, Input } from '@features/ui';
import { Controller, useForm } from 'react-hook-form';
import {
  FinancialsFormData,
  schemaFinancialsForm,
} from '@src/types/exchangePackages.ts';
import { yupResolver } from '@hookform/resolvers/yup';

interface FinancialsFormProps {
  values?: FinancialsFormData;
  onSubmit?: (values: FinancialsFormData) => void;
}
export const FinancialsForm: FC<FinancialsFormProps> = ({
  values,
  onSubmit,
}) => {
  const handleSubmitForm = (data: FinancialsFormData) => {
    onSubmit?.(data);
  };

  const { control, handleSubmit } = useForm<FinancialsFormData>({
    resolver: yupResolver(schemaFinancialsForm),
    defaultValues: values,
  });

  return (
    <div className={'mt-9'}>
      <div className={'flex flex-col gap-y-2 mb-8'}>
        <p>Rithmic Account Info</p>
        <p>
          Warning - Changing values in here will effect all new Rithmic
          accounts!
        </p>
      </div>
      <form autoComplete="off" onSubmit={handleSubmit(handleSubmitForm)}>
        <div className={'flex lg:flex-row flex-col w-full gap-7.5'}>
          <div className={'flex-1 flex flex-col gap-y-7.5'}>
            <Controller
              control={control}
              name="cashInHand"
              render={({ field }) => (
                <div className={'flex flex-col gap-y-3.5'}>
                  <p>Cash In Hand $</p>
                  <Input textSize={'xs'} variant={'secondary'} {...field} />
                </div>
              )}
            />
            <Controller
              control={control}
              name="profitTarget"
              render={({ field }) => (
                <div className={'flex flex-col gap-y-3.5'}>
                  <p>Profit Target $</p>
                  <Input textSize={'xs'} variant={'secondary'} {...field} />
                </div>
              )}
            />
          </div>
          <Controller
            control={control}
            name="autoLiquidate"
            render={({ field }) => (
              <div className={'flex flex-1 flex-col gap-y-3.5'}>
                <p>Auto Liquidate $</p>
                <Input textSize={'xs'} variant={'secondary'} {...field} />
              </div>
            )}
          />
          <div className={'flex-1 flex flex-col gap-y-7.5'}>
            <Controller
              control={control}
              name="autoLiquidateMinMax"
              render={({ field }) => (
                <div className={'flex flex-col gap-y-3.5'}>
                  <p>Auto Liquidate Min Max $</p>
                  <Input textSize={'xs'} variant={'secondary'} {...field} />
                </div>
              )}
            />
            <Controller
              control={control}
              name="proAutoLiquidateMinMax"
              render={({ field }) => (
                <div className={'flex flex-col gap-y-3.5'}>
                  <p>PRO Auto Liquidate Min Max $</p>
                  <Input textSize={'xs'} variant={'secondary'} {...field} />
                </div>
              )}
            />
          </div>
          <Controller
            control={control}
            name="durationDay"
            render={({ field }) => (
              <div className={'flex flex-1 flex-col gap-y-3.5'}>
                <p>Duration (DAYS)</p>
                <Input textSize={'xs'} variant={'secondary'} {...field} />
              </div>
            )}
          />
        </div>
        <p className={'mt-11 mb-5'}>Rithmic Trader Acoount Limits</p>
        <div className={'flex lg:flex-row flex-col w-full gap-7.5'}>
          <div className={'flex-1 flex flex-col gap-y-7.5'}>
            <Controller
              control={control}
              name="buyLimit"
              render={({ field }) => (
                <div className={'flex flex-col gap-y-3.5'}>
                  <p>Buy Limit</p>
                  <Input textSize={'xs'} variant={'secondary'} {...field} />
                </div>
              )}
            />
            <Controller
              control={control}
              name="minAccountBalance"
              render={({ field }) => (
                <div className={'flex flex-col gap-y-3.5'}>
                  <p>Min Account Balance $</p>
                  <Input textSize={'xs'} variant={'secondary'} {...field} />
                </div>
              )}
            />
            <Controller
              control={control}
              name="commissionRate"
              render={({ field }) => (
                <div className={'flex flex-col gap-y-3.5'}>
                  <p>STOCKS - Commission Rate $</p>
                  <Input textSize={'xs'} variant={'secondary'} {...field} />
                </div>
              )}
            />
          </div>
          <div className={'flex-1 flex flex-col gap-y-7.5'}>
            <Controller
              control={control}
              name="sellLimit"
              render={({ field }) => (
                <div className={'flex flex-col gap-y-3.5'}>
                  <p>Sell Limit</p>
                  <Input textSize={'xs'} variant={'secondary'} {...field} />
                </div>
              )}
            />
            <Controller
              control={control}
              name="netOpenValueUnit"
              render={({ field }) => (
                <div className={'flex flex-col gap-y-3.5'}>
                  <p>Net Open Value Unit $</p>
                  <Input textSize={'xs'} variant={'secondary'} {...field} />
                </div>
              )}
            />
          </div>
          <div className={'flex-1 flex flex-col gap-y-7.5'}>
            <Controller
              control={control}
              name="maxOrder"
              render={({ field }) => (
                <div className={'flex flex-col gap-y-3.5'}>
                  <p>Max order</p>
                  <Input textSize={'xs'} variant={'secondary'} {...field} />
                </div>
              )}
            />
            <Controller
              control={control}
              name="minMarginBalance"
              render={({ field }) => (
                <div className={'flex flex-col gap-y-3.5'}>
                  <p>Min Margin Balance $</p>
                  <Input textSize={'xs'} variant={'secondary'} {...field} />
                </div>
              )}
            />
          </div>
          <div className={'flex-1 flex flex-col gap-y-7.5'}>
            <Controller
              control={control}
              name="lossLimit"
              render={({ field }) => (
                <div className={'flex flex-col gap-y-3.5'}>
                  <p>Loss Limit $</p>
                  <Input textSize={'xs'} variant={'secondary'} {...field} />
                </div>
              )}
            />
            <Controller
              control={control}
              name="proLossLimit"
              render={({ field }) => (
                <div className={'flex flex-col gap-y-3.5'}>
                  <p>PRO Loss limit $</p>
                  <Input textSize={'xs'} variant={'secondary'} {...field} />
                </div>
              )}
            />
          </div>
        </div>
        <div className={'flex w-full justify-end'}>
          <Button
            className={'mt-6 mb-1 w-[72px]'}
            size={'sm'}
            type={'submit'}
            variant={'lime'}
          >
            Save
          </Button>
        </div>
      </form>
    </div>
  );
};
